const CONTRACT_CREATED = 1
const CONTRACT_STATUS_CHANGED = 2
const CONTRACT_NEW_COMMENT = 3
const CONTRACT_NEW_ATTACHMENT = 4
const CONTRACT_FOLLOW_UP = 5
const CUSTOMER_BIRTHDAY = 6
const CUSTOMER_CALL_REMINDER = 7
const CUSTOMER_CHILD_BIRTHDAY = 9
const CUSTOMER_PET_BIRTHDAY = 10
const CUSTOMER_FINISHED_PRE_INTERVIEW = 11
const CUSTOMER_LEFT_FIELDS = 12
const LEAD_GENERATE = 13
const LEAD_INTEREST_FINANCIAL_PLANNING = 14
const FINANCIAL_PLANNING_OVERDUE = 15
const PRE_INTERVIEW_INCOMPLETE = 17
const FINANCIAL_DIAGNOSIS = 18
const DIGITAL_FRANCHISE_PURCHASE_CREATED = 19
const CUSTOMER_NO_CONTACT_ALERT = 21
const SUPPORT_STRATEGIC_CONTACT_REMINDER = 22
const SUPPORT_NO_HISTORY_REMINDER = 23
const REQUEST_SPECIALIST_ASSIGNED = 25
const SPECIALTY_ASSIGNED = 29
// Alteração financeira em lote. O tipo existe no backend desde a entrega da governança de lotes,
// e a ausência dele AQUI é o que fazia a notificação chegar com o corpo em branco: o mapa abaixo
// não tinha o caso, a função caía no default e devolvia string vazia. O item aparecia no inbox
// com o badge e a data, e nenhum texto — enquanto todo o resumo já vinha gravado em `metadata`.
const FINANCIAL_BATCH_APPLIED = 32

const CUSTOMER_CHAT_INVITED = 33
const CUSTOMER_CHAT_NEW_MESSAGE = 34
const CUSTOMER_CHAT_ASSIGNED = 35

// Nomes do chat vêm de cadastro do app (o próprio cliente digita): escapar antes de montar HTML.
const escapeHtml = value => String(value == null ? '' : value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')

const customerChatLink = metadata => {
    const name = `<b>${escapeHtml(metadata.customer_name || 'Cliente')}</b>`
    if (!metadata.conversation_id) return name
    return `<a href="/customer-chat?conversation=${encodeURIComponent(metadata.conversation_id)}">${name}</a>`
}

const OWN = 1
const DIRECT_TEAM = 2
const SUPPORT = 3

export default function getNotificationMessage(metadata, notification_type, notification_tag)
{
    var message = ''
    if( notification_type == CONTRACT_NEW_COMMENT || 
        notification_type == CONTRACT_STATUS_CHANGED ||
        notification_type == CONTRACT_NEW_ATTACHMENT
    ){
        if(!notification_tag || notification_tag == DIRECT_TEAM){
            message = 'O contrato do PN <b> ' + metadata.consultant_name + '</b>'
            if(notification_tag == DIRECT_TEAM){
                message += ' da sua equipe direta'
            }
            message += ' do tipo <b>' + metadata.product_name +
                '</b> do cliente <b>' + metadata.customer_name + '</b>'
            if(metadata.support_consultant_name){
                message += ' orientado pelo PN <b>' + metadata.support_consultant_name + '</b>'
            }
        }

        if(notification_tag == OWN){
            message = 'O seu contrato do tipo <b> ' + metadata.product_name + 
                '</b> do cliente <b> ' + metadata.customer_name + '</b>'
            if(metadata.support_consultant_name){
                message += ' orientado pelo PN <b>' + metadata.support_consultant_name + '</b>'
            }
        }

        if(notification_tag == SUPPORT){
            message = 'O contrato que você é o especialista do PN <b> ' + metadata.consultant_name + '</b>' +
                ' do tipo <b>' + metadata.product_name +
                '</b> do cliente <b> ' + metadata.customer_name + '</b>'
        }
    
        if(notification_type == CONTRACT_NEW_COMMENT){ 
            message += ' recebeu o comentário: <b>' + metadata.comment_text + '</b>.'
        }
        if(notification_type == CONTRACT_STATUS_CHANGED){ 
            message += ' mudou para o status  <b>'+ metadata.contract_status_name +'</b>.'
        }
        if(notification_type == CONTRACT_NEW_ATTACHMENT){ 
            message += ' recebeu um anexo.'
        }
    }

    if(notification_type == CUSTOMER_BIRTHDAY){
        message = 'Hoje é o aniversário de <b>' + metadata.customer_name + '</b>!'
    }

    if(notification_type == CUSTOMER_FINISHED_PRE_INTERVIEW){
        message = '<b>' + metadata.customer_name + '</b> finalizou o formulário de pré-entrevista!'
    }
  
    if(notification_type == CUSTOMER_LEFT_FIELDS){
        let fieldsList = '';

        if (metadata.missing_fields) {
            for (let i = 0; i < metadata.missing_fields.length; i++) {
                fieldsList += metadata.missing_fields[i];
                if (i < metadata.missing_fields.length - 1) {
                    fieldsList += (i === metadata.missing_fields.length - 2) ? ' e ' : ', ';
                }
            }
        }
        message = `O cadastro do cliente <b>${metadata.customer_name}</b> está pendente de: ${fieldsList}. Consulte o cliente e preencha quanto antes!`;
    }
  
    if(notification_type == CUSTOMER_CHILD_BIRTHDAY){
        message = 'Hoje é o aniversário de <b>' + metadata.child_name + '</b>, filho(a) de <b>' + metadata.customer_name + '</b>!'
    }

    if(notification_type == CUSTOMER_PET_BIRTHDAY){
        message = 'Hoje é o aniversário de <b>' + metadata.pet_name + '</b>, pet de <b>' + metadata.customer_name + '</b>!'
    }

    if(notification_type == CUSTOMER_CALL_REMINDER){
        message = 'Você possui um lembrete hoje às <b>' + metadata.call_reminder_hour + '</b>' + 
           ' para o cliente <b>'+ metadata.customer_name + '</b>!'
    }

    if(notification_type == LEAD_GENERATE){
        message = '<b>' + metadata.customer_name + '</b> acabou de se cadastrar através da Landing Page "' + metadata.landing_page_name + '"!'
    }

    if(notification_type == FINANCIAL_PLANNING_OVERDUE){
        message = metadata.message
    }

    if (notification_type == PRE_INTERVIEW_INCOMPLETE) {
    message = `O cliente <b>${metadata.customer_name}</b> ainda não preencheu a pré-entrevista. Oriente-se a cobrar o preenchimento por ligação ou mensagem.`;
    
    }

    if (notification_type == FINANCIAL_DIAGNOSIS) {
        message = `Lembrete: Agendamento <b>${metadata.customer_name}</b>, montar o diagnóstico financeiro e confirmar a reunião explicando os benefícios da análise.`;
    }

    if(notification_type == DIGITAL_FRANCHISE_PURCHASE_CREATED){
        message = 'Uma nova compra de Franquia Digital está pendente de aprovação. Por favor, acesse o sistema para revisar e aprovar ou rejeitar a compra.'
    }

    if(notification_type == CUSTOMER_NO_CONTACT_ALERT){
        message = metadata.message
    }

    if(
        notification_type == SUPPORT_STRATEGIC_CONTACT_REMINDER ||
        notification_type == SUPPORT_NO_HISTORY_REMINDER
    ){
        message = metadata.message
    }

    if(notification_type == REQUEST_SPECIALIST_ASSIGNED){
        const customerLink = `<a href="/cliente/${metadata.customer_id}/detalhes"><b>${metadata.customer_name}</b></a>`
        message = `Você foi atribuído(a) como especialista do cliente ${customerLink}.`

        if (metadata.department_name) {
            message += ` Unidade de Negócio: <b>${metadata.department_name}</b>.`
        }

        if (metadata.assigned_by_name) {
            message += ` A atribuição foi realizada por <b>${metadata.assigned_by_name}</b>.`
        }
    }

    if(notification_type == SPECIALTY_ASSIGNED){
        const customerLink = `<a href="/cliente/${metadata.customer_id}/detalhes"><b>${metadata.customer_name}</b></a>`
        message = `Você foi atribuído(a) como especialista de <b>${metadata.department_name}</b> para o cliente ${customerLink}.`

        if (metadata.assigned_by_name) {
            message += ` Atribuído por <b>${metadata.assigned_by_name}</b>.`
        }
    }

    if (notification_type == FINANCIAL_BATCH_APPLIED) {
        const pns = Number(metadata.affected_consultants_count) || 0
        const contratos = Number(metadata.affected_contracts_count) || 0
        const competencias = Array.isArray(metadata.competences) ? metadata.competences : []

        // O verbo concorda com a quantidade de PNs: "1 PN foram afetados" é o tipo de erro que
        // some numa revisão de código e nunca some na tela de quem recebe a notificação.
        const alvo = pns === 1 ? '<b>1 PN</b> foi afetado' : `<b>${pns} PNs</b> foram afetados`
        message = `A operação <b>${metadata.reference}</b> foi aplicada e ${alvo}.`

        if (contratos) {
            message += ` ${contratos === 1 ? '<b>1 contrato</b> alterado' : `<b>${contratos} contratos</b> alterados`}.`
        }

        // Valor líquido com sinal: crédito e débito somam efeitos opostos, e o número sem sinal
        // não diz se a operação pôs ou tirou dinheiro do campo.
        if (metadata.net_diff !== undefined && metadata.net_diff !== null) {
            const liquido = Number(metadata.net_diff) || 0
            const sinal = liquido < 0 ? '-' : '+'
            const formatado = Math.abs(liquido).toLocaleString('pt-BR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            })
            message += ` Efeito líquido: <b>${sinal} R$ ${formatado}</b>.`
        }

        if (competencias.length) {
            message += ` Competências: <b>${competencias.join(', ')}</b>.`
        }

        if (metadata.executed_by_name) {
            const papel = metadata.executed_by_role_name ? ` (${metadata.executed_by_role_name})` : ''
            message += ` Executado por <b>${metadata.executed_by_name}</b>${papel}.`
        }

        if (metadata.reason) {
            message += ` Motivo: ${metadata.reason}`
        }
    }

    if(notification_type == CUSTOMER_CHAT_INVITED){
        message = `A conversa com o cliente ${customerChatLink(metadata)} foi direcionada a você`
        message += metadata.actor_name ? ` por <b>${escapeHtml(metadata.actor_name)}</b>.` : '.'
    }

    if(notification_type == CUSTOMER_CHAT_NEW_MESSAGE){
        message = `Nova mensagem de ${customerChatLink(metadata)} no chat do app.`
    }

    if(notification_type == CUSTOMER_CHAT_ASSIGNED){
        message = `Você é o novo responsável pela conversa com ${customerChatLink(metadata)}.`
    }

    return message
}
